














































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { DropBox } from '@/domain/entities/DropBox'

@Component
export default class DropBoxMonitoringListRow extends Vue {
  @Prop({ required: true }) item!: DropBox
  @Prop({ required: true }) canAccessDetail!: boolean

  get detailPath(): string {
    if (!this.item.externalId) return ''
    return `/drop-box/${this.item.externalId}?origin=monitoring`
  }

  get dropBoxId(): string {
    return this.item.externalId || this.item.serialNumber || '-'
  }

  get capacityDisplay(): number {
    const c = this.item.capacityPercentage
    return c !== undefined && c !== null ? c : 0
  }

  get statusLabel(): string {
    if (!this.item.machineCondition || this.item.machineCondition === '-') {
      return 'Unknown'
    }
    const mc = this.item.machineCondition.toUpperCase()
    if (mc === 'GREEN') return 'Online'
    if (mc === 'ORANGE') return 'Issue'
    if (mc === 'RED') return 'Offline'
    return 'Offline'
  }

  get isGreen(): boolean {
    const mc = (this.item.machineCondition || '').toUpperCase()
    return mc === 'GREEN'
  }

  get isOrange(): boolean {
    const mc = (this.item.machineCondition || '').toUpperCase()
    return mc === 'ORANGE'
  }

  get isRed(): boolean {
    const mc = (this.item.machineCondition || '').toUpperCase()
    return mc === 'RED'
  }

  get statusBadgeClass(): string {
    const mc = (this.item.machineCondition || '').toUpperCase()
    if (mc === 'GREEN') {
      return 'bg-green-200 text-green-800'
    }
    if (mc === 'ORANGE') {
      return 'bg-orange-200 text-orange-800'
    }
    if (mc === 'RED') {
      return 'bg-red-200 text-red-800'
    }
    return 'bg-gray-200 text-gray-800'
  }

  get statusDotClass(): string {
    const mc = (this.item.machineCondition || '').toUpperCase()
    if (mc === 'GREEN') return 'bg-green-600 status-dot-breathe-slow'
    if (mc === 'ORANGE') return 'bg-orange-500 status-dot-breathe-medium'
    if (mc === 'RED') return 'bg-red-500 status-dot-pulse-fast'
    return 'bg-gray-500 status-dot-pulse-fast'
  }

  private onViewDetail(): void {
    if (this.item.externalId) {
      this.$emit('view-detail', this.item.externalId)
    }
  }

  private getCapacityBarClass(capacity: number | undefined): string {
    const n = capacity !== undefined && capacity !== null ? capacity : 0
    if (n >= 80) return 'bg-red-500'
    if (n >= 50) return 'bg-yellow-500'
    return 'bg-green-500'
  }
}
